import { object, array, string } from 'yup';
import { validationSchemaProps } from 'enums/TransportationEnums';

export interface SupplierDetailsProps {
  supplierFor: string;
  ind: number;
  suppliername: string;
}

interface ItemProps {
  label: string | boolean;
  value: string | boolean;
  key?: number | string;
}
export const TransportationConstants = {
  USER_DETAILS: 'userDetails',
  CLOSE_LABEL: 'Close anyway',
  CONFIRM_LABEL: 'Save & Proceed',
  HEADING: 'Do you want to close the current page without saving?',
};
const SupplierMeta: ItemProps[] = [
  {
    value: 'Supplier A',
    label: 'Supplier A',
    key: '1',
  },
  {
    value: 'Supplier B',
    label: 'Supplier B',
    key: '2',
  },
  {
    value: 'Supplier C',
    label: 'Supplier C',
    key: '3',
  },
];
export const TemperatureControl: ItemProps[] = [
  {
    value: 'ambient',
    label: 'Ambient',
    key: '1',
  },
  {
    value: 'refrigerated',
    label: 'Refrigerated',
    key: '2',
  },
  {
    value: 'frozen',
    label: 'Frozen',
    key: '3',
  },
];
export const IngredientFields = [
  {
    name: 'ingredientName',
    placeholder: 'Enter Ingredient Name',
    label: 'Enter Ingredient Name',
    size: 'big',
    select: true,
    disabled: true,
    checkbox: false,
  },
  {
    name: 'supplier',
    placeholder: 'Supplier',
    label: 'Supplier',
    size: 'big',
    select: true,
    disabled: false,
    checkbox: false,
    options: SupplierMeta,
  },
  {
    name: 'temperatureControl',
    placeholder: 'Temperature control',
    label: 'Temperature control',
    size: 'big',
    select: true,
    disabled: false,
    checkbox: false,
    options: TemperatureControl,
  },
  {
    name: 'viaAir',
    placeholder: 'Check this box if transportation is via air',
    label: 'Check this box if transportation is via air',
    size: 'big',
    select: false,
    disabled: false,
    checkbox: true,
  },
];

export const packageMaterialFields = [
  {
    name: 'packingMaterialName',
    placeholder: 'Enter packaging material name/origin',
    label: 'Enter packaging material name/origin',
    size: 'big',
    select: true,
    disabled: true,
    checkbox: false,
  },
  {
    name: 'packingSupplier',
    placeholder: 'Supplier',
    label: 'Supplier',
    size: 'big',
    select: true,
    disabled: false,
    checkbox: false,
  },
  {
    name: 'packingTemperatureControl',
    placeholder: 'Temperature control',
    label: 'Temperature control',
    size: 'big',
    select: true,
    disabled: false,
    checkbox: false,
  },
  {
    name: 'packingViaAir',
    placeholder: 'Check this box if transportation is via air',
    label: 'Check this box if transportation is via air',
    size: 'big',
    select: false,
    disabled: false,
    checkbox: true,
  },
];

const ingredientSchema = object().shape({
  multipleOrigin: array().of(
    object().shape({
      supplier: string().required(validationSchemaProps.ERROR_MESSAGE),
      temperatureControl: string().required(
        validationSchemaProps.ERROR_MESSAGE
      ),
    })
  ),
});

const packagingSchema = object().shape({
  multipleOrigin: array().of(
    object().shape({
      supplier: string().required(validationSchemaProps.ERROR_MESSAGE),
    })
  ),
});

export const validationSchema = object({
  ingredients: array().of(ingredientSchema),
  packageMaterials: array().of(packagingSchema),
});
